import { forwardRef } from "react";
import { cn } from "../../lib/utils"

const Input = forwardRef(({ className, type, error, warning, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-neutral-400 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-misc-focus disabled:cursor-not-allowed",
        error ? "input-error" : warning ? "input-warning" : "input-field",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }
